import { Fragment, useState } from "react";
import { useModal } from "../../../hooks/useModal";
import PageWrapper from "../../common/components/PageWrapper";
import BannerListBox from "../components/BannerListBox";
import MetadataBox from "../components/MetadataBox";
import UpdateBannerModal from "../components/UpdateBannerModal";

export default function BannerContainer() {
  const [isUpdateModalOpen, { open, close }] = useModal();
  const [bannerId, setBannerId] = useState<string | null>(null);

  const onModalOpen = (bannerId: string | null) => {
    setBannerId(bannerId);
    open();
  };

  return (
    <Fragment>
      {isUpdateModalOpen && (
        <UpdateBannerModal
          open={isUpdateModalOpen}
          onClose={close}
          bannerId={bannerId}
        />
      )}
      <PageWrapper isColumnFlex={false}>
        <MetadataBox onCreateBanner={() => onModalOpen(null)} />
        <BannerListBox onUpdateBanner={onModalOpen} />
      </PageWrapper>
    </Fragment>
  );
}
